// import React from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Navbar from "./Pages/LandingPage/Navbar";
// import Login from "./Pages/Login/Login";
// import Signup from "./Pages/Signup/Signup";
// import Dashboard from "./Components/Dashboard/Dashboard";
// import Contact from "./Pages/Contact";
// import MainDashboardContent from "./Pages/MainDashboardContent";
// import AddLeads from "./Pages/Leads/AddLeads";
// import LeadList from "./Pages/Leads/LeadList";
// import CompanyRegistration from "./Pages/Company/CompanyRegistration";
// import CompanyList from "./Pages/Company/CompanyList";
// import EmployeeRegistration from "./Pages/EmployeeRegistration/EmployeeRegistration";
// import EmployeeList from "./Pages/EmployeeRegistration/EmployeeList";
// import UpdateLeeds from "./Pages/Leads/UpdateLeeds";
// import EditCompany from "./Pages/Company/CompanyListUpdate";
// import EmployeeUpdate from "./Pages/EmployeeRegistration/EmployesUpdate";
// import ProtectedRoute from "./ProtectedRoute";

// import ClientRegistration from "./Pages/Client/ClientRegistration";
// import ClientList from "./Pages/Client/ClientList";
// import ClientUpdate from "./Pages/Client/ClientUpdate";
// import FitnessUpdate from "./Pages/Client/FitnessUpdate";
// import PermitUpdate from "./Pages/Client/PermitUpdate";


// import AddPitched from "./Pages/Pitched/AddPitched";
// import PitchedList from "./Pages/Pitched/PitchedList";
// import UpdatePitched from "./Pages/Pitched/UpdatePitched";

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="" element={<Navbar />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<Signup />} />
//         {/* <Route
//           path="/dashboard"
//           element={<ProtectedRoute component={Dashboard} />}
//         > */}
//         <Route path="dashboard" element={<Dashboard />} />
//           <Route index element={<MainDashboardContent />} />
//           <Route path="add-lead" element={<AddLeads />} />
//           <Route path="lead-list" element={<LeadList />} />
//           <Route path="contact" element={<Contact />} />
//           <Route path="company-add" element={<CompanyRegistration />} />
//           <Route path="company-list" element={<CompanyList />} />
//           <Route
//             path="Employee-Registration"
//             element={<EmployeeRegistration />}
//           />
//           <Route path="EmployeeList" element={<EmployeeList />} />
//           <Route path="updateLead/:leadId" element={<UpdateLeeds />} />
//           <Route
//             path="edit-company/:establishmentId"
//             element={<EditCompany />}
//           />
//           <Route
//             path="employee-update/:employeeId"
//             element={<EmployeeUpdate />}
//           />
//           <Route
//             path="pitched-add"
//             element={<AddPitched />}
//           />
//           <Route
//             path="pitched-list"
//             element={<PitchedList />}
//           />

//           <Route
//             path="pitched-update/:pitchId"
//             element={<UpdatePitched />}
//           />
//           <Route path="client-registration" element={<ClientRegistration />} />
//           <Route path="client-list" element={<ClientList />} />
//           <Route path="client-update/:itemId" element={<ClientUpdate />} />
//           <Route path="fitness-update/:itemId" element={<FitnessUpdate />} />
//           <Route path="permit-update/:itemId" element={<PermitUpdate />} />
//         </Route>
//       </Routes>
//     </Router>
//   );
// }

// export default App;
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./Pages/LandingPage/Navbar";
import Login from "./Pages/Login/Login";
import Signup from "./Pages/Signup/Signup";
import Dashboard from "./Components/Dashboard/Dashboard";
import Contact from "./Pages/Contact";
import MainDashboardContent from "./Pages/MainDashboardContent";
import AddLeads from "./Pages/Leads/AddLeads";
import LeadList from "./Pages/Leads/LeadList";
import CompanyRegistration from "./Pages/Company/CompanyRegistration";
import CompanyList from "./Pages/Company/CompanyList";
import EmployeeRegistration from "./Pages/EmployeeRegistration/EmployeeRegistration";
import EmployeeList from "./Pages/EmployeeRegistration/EmployeeList";
import UpdateLeeds from "./Pages/Leads/UpdateLeeds";
import EditCompany from "./Pages/Company/CompanyListUpdate";
import EmployeeUpdate from "./Pages/EmployeeRegistration/EmployesUpdate";
import ProtectedRoute from "./ProtectedRoute";

import ClientRegistration from "./Pages/Client/ClientRegistration";
import ClientList from "./Pages/Client/ClientList";
import ClientUpdate from "./Pages/Client/ClientUpdate";
import FitnessUpdate from "./Pages/Client/FitnessUpdate";
import PermitUpdate from "./Pages/Client/PermitUpdate";

import AddPitched from "./Pages/Pitched/AddPitched";
import PitchedList from "./Pages/Pitched/PitchedList";
import UpdatePitched from "./Pages/Pitched/UpdatePitched";
import PollutionUpdate from "./Pages/Client/PollutionUpdate";
import TaxUpdate from "./Pages/Client/TaxUpdate";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="" element={<Navbar />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
       <Route
          path="/dashboard"
          element={<ProtectedRoute component={Dashboard} />}
        >
          <Route index element={<MainDashboardContent />} />
          <Route path="add-lead" element={<AddLeads />} />
          <Route path="lead-list" element={<LeadList />} />
          <Route path="contact" element={<Contact />} />
          <Route path="company-add" element={<CompanyRegistration />} />
          <Route path="company-list" element={<CompanyList />} />
          <Route
            path="Employee-Registration"
            element={<EmployeeRegistration />}
          />
          <Route path="EmployeeList" element={<EmployeeList />} />
          <Route path="updateLead/:leadId" element={<UpdateLeeds />} />
          <Route path="edit-company/:establishmentId" element={<EditCompany />} />
          <Route path="employee-update/:employeeId" element={<EmployeeUpdate />} />
          <Route path="pitched-add" element={<AddPitched />} />
          <Route path="pitched-list" element={<PitchedList />} />
          <Route path="pitched-update/:pitchId" element={<UpdatePitched />} />
          <Route path="client-registration" element={<ClientRegistration />} />
          <Route path="client-list" element={<ClientList />} />
          <Route path="client-update/:itemId" element={<ClientUpdate />} />
          <Route path="fitness-update/:itemId" element={<FitnessUpdate />} />
          <Route path="permit-update/:itemId" element={<PermitUpdate />} />
          <Route path="polution-update/:itemId" element={<PollutionUpdate />} />
          <Route path="tax-update/:itemId" element={<TaxUpdate/>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
